import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';

const chapters = [
  {
    title: 'Intelligence & Strategy',
    problem: 'We do not know where to compete.',
    approach: 'Evidence-led positioning and campaign mapping.',
    services: ['Competitive monitoring', 'Brand positioning', 'Campaign strategy', 'Decision-ready recommendations']
  },
  {
    title: 'Creative & Content',
    problem: 'Our messaging is not cutting through.',
    approach: 'High-fidelity creative hooks and scalable content systems.',
    services: ['Advertising creative', 'Social content', 'Copywriting', 'Visual Design']
  },
  {
    title: 'Brand & Digital',
    problem: 'Our digital presence is disconnected.',
    approach: 'Conversion-focused identity and user experience.',
    services: ['Identity systems', 'Websites & Landing pages', 'UX/UI Design', 'SEO Strategy']
  }
];

const process = ['Diagnose', 'Define', 'Design', 'Produce', 'Deploy', 'Improve'];

export default function CreativeServices() {
  return (
    <div className="bg-black pt-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mb-32">
          <h1 className="text-6xl md:text-8xl font-serif font-bold mb-10 leading-[1.1]">Turn Strategic Clarity Into Creative Action.</h1>
          <p className="text-3xl text-zinc-400 font-light leading-relaxed">Exceptional execution driven by market intelligence.</p>
        </div>

        <div className="space-y-24 mb-40">
          {chapters.map((chapter, i) => (
            <div key={i} className="grid grid-cols-1 lg:grid-cols-2 gap-20 py-20 border-t border-zinc-900">
              <div>
                <h3 className="text-4xl font-serif font-bold mb-8">{chapter.title}</h3>
                <div className="space-y-6 mb-12">
                  <p className="text-zinc-500 italic text-lg">"{chapter.problem}"</p>
                  <p className="text-zinc-300 text-xl leading-relaxed">{chapter.approach}</p>
                </div>
                <Link to="/contact" className="bg-zinc-900 text-white px-8 py-4 rounded font-bold uppercase tracking-widest text-[10px] hover:bg-blue-600 transition-all">Start a Project</Link>
              </div>
              <div className="bg-zinc-950 p-12 rounded-[3rem] border border-zinc-900">
                <h4 className="text-xs font-bold tracking-widest text-zinc-600 uppercase mb-8">Deliverables</h4>
                <ul className="space-y-6">
                  {chapter.services.map((service, j) => (
                    <li key={j} className="text-xl text-zinc-400 flex items-center gap-6">
                      <span className="w-1.5 h-1.5 bg-blue-600 rounded-full"></span>
                      {service}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        <section className="py-32 border-y border-zinc-900">
          <h2 className="text-xs font-bold tracking-[0.4em] text-zinc-500 uppercase mb-20 text-center">The Maxmark Process</h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
            {process.map((p, i) => (
              <div key={i} className="text-center">
                <span className="text-4xl font-serif font-bold text-zinc-800 block mb-4">0{i+1}</span>
                <span className="text-sm font-bold uppercase tracking-widest text-white">{p}</span>
              </div>
            ))}
          </div>
        </section>

        <section className="py-40 text-center">
          <h2 className="text-5xl font-serif font-bold mb-10">Tell us the result you need—not only the asset you want.</h2>
          <Link to="/contact" className="bg-blue-600 text-white px-12 py-6 rounded font-bold uppercase tracking-widest text-xs inline-block"> Start a Strategic Project </Link>
        </section>
      </div>
    </div>
  );
}